module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I gratefully acknowledge the contributions of several persons who know a lot and care a lot about Edisto’s history, and whose generous help is reflected in this final product:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACK")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OINEAU")]), _vm._v(" made available his amazing ten-year collection of Edisto Island maps and plantation plats, and helped me for days at a time to piece together the mosaic of early land history.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVID")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YBRAND")]), _vm._v(" made available to me his now-completed master map of Edisto plantations in the 1850s ("), _c('span', {
    attrs: {
      "href": "#/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")]), _vm._v("), and was always available for me to consult with when I was stuck.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORMA")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RMSTRONG")]), _vm._v(" repeatedly located needed materials in Charleston libraries, archives and land records when I was five hundred miles away in Virginia and discovered holes in my data set.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICHARD")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORCHER")]), _vm._v(" generously sent me whole chapters of "), _c('i', [_vm._v("The Story of Sea Island Cotton")]), _vm._v(" while it was still in manuscript, to save me the effort of parallel research on its history and production.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TEPHANIE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PENCER")]), _vm._v(" edited my final manuscript of both volumes, and formatted them to the publisher’s specifications, while working a full-time job. Greater love hath no daughter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTY")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URRAY")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RYAN")]), _vm._v(" gave me free use of a vacation cottage on Edisto Island, at any time and for any length of time, for four years, as a base of operations for in-state research. What can I say?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Several published authors gave me moral support and reassurance when I most needed it. First and foremost was S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEILA")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EARDSLEY")]), _vm._v(", as noted above. Another was N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICK")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INDSAY")]), _vm._v(". And another was H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARVEY")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAL")]), _vm._v(". If they think you can do it, who are you to doubt yourself?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The research for this book has been a true community effort. Dozens of persons responded to my appeals and gave me copies of privately held documents, or steered me to valuable sources of which I was unaware, or both. They include:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILL")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LBERGOTTI")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETER")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDREWS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RTHUR")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AILEY")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLY AND")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INCKNEY")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AILEY")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OB")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AYNARD")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACK")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OINEAU")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARY")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGHTWELL")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATRICK AND")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HODA")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTLER")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARDWELL")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MY")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONNOR")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILL")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOPER")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ULBERTSON")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARBY")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARAH")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICK")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARY")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOYD")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EWIS")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAMPTON")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LAINE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEMAN")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("P.C. G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIMBALL")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARING")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATES")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AZLEHURST")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RANCES")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORSLEY")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORDON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUSTON")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LICE AND")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARRY")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTSON")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LORENCE")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IZER")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HUCK")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOTZBERGER")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILL")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AWSON")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICK AND")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBOSE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INDSAY")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVID")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YBRAND")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LARA")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACKENZIE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OBERT")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACKINTOSH")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AT")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARTIN")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("C")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLLUM")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INDA")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("C")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AIN")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERRY")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EGGETT")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARION")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITCHELL")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HICK")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORRISON")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARION")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORWOOD")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LAF")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TTO")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANCY")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EEPLES")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ED")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OCKMAN")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANN")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSTON")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARY")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AKE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AM")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANTO")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EN")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("KARDON")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UD")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("KIDMORE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANIEL")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PENCER")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TEPHANIE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PENCER")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTTIE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOMAS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISH")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOMPSON")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARY")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OWNSEND")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EGGIE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASHINGTON")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDGE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EIDMAN")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URTIS")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORTHINGTON")])]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("I have no doubt that errors have crept in despite all the help I received. The errors are all mine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URRAY")]), _vm._v(" cousins on Edisto Island—G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERRY")]), _vm._v(" and O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("KIE")]), _vm._v(", Jim and Linda—took me into their homes and their families whenever I was around, no questions asked. There is no better way to relax from the grind than to “hang out” with family—and eat delicious seafood. Thanks, you all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, Lucy Norman Spencer endured seven years of marriage to a novice author who bit off more than he imagined. She stood by me longer than I deserved, and I am very grateful for her support.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5abd810","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acknowledgement.vue
// module id = 75
// module chunks = 0